import { LoadingButton } from "@mui/lab";
import { Avatar, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changePassword,
  getAuthData,
  setCurrentScreen,
} from "../../features/auth/authSlice";
import { IArrowBack } from "../../utils/icons.utils";
import { userResetPassword } from "../../utils/validators";
import PasswordInput from "../PasswordInput";

const ChangePassword = () => {
  const { loading } = useSelector(getAuthData),
    [isMatch, setMatch] = React.useState(false),
    dispatch = useDispatch(),
    [error, setError] = React.useState(""),
    model = {
      newPassword: "",
      confirmPassword: "",
    },
    { values, handleBlur, handleChange, handleSubmit, errors, touched } =
      useFormik({
        validationSchema: userResetPassword,
        initialValues: model,
        onSubmit: (value) => {
          if (isMatch) dispatch(changePassword(value));
        },
      });

  React.useEffect(() => {
    const match = values.newPassword === values.confirmPassword;
    if (!match && !errors.confirmPassword && !errors.newPassword) {
      setError("Password mismatch");
    }
    setMatch(match);
  }, [
    values.newPassword,
    values.confirmPassword,
    errors.confirmPassword,
    errors.newPassword,
  ]);

  return (
    <Box className="pt-24" data-cy="change-password-container">
      <Box
        display="flex"
        alignItems="center"
        marginBottom="2em"
        data-cy="change-password-back-button"
      >
        <Avatar
          src={IArrowBack}
          className="w-10 h-10 hover:bg-gray-400 p-2 mr-2 cursor-pointer"
          onClick={(_) => dispatch(setCurrentScreen("login"))}
          data-cy="change-password-back-icon"
        />
        <Typography fontSize="20px">Go back</Typography>
      </Box>

      <Typography
        component={"h4"}
        variant={"h4"}
        className="font-bold"
        data-cy="change-password-screen"
      >
        Change Password
      </Typography>

      <Typography
        className="text-[14px] text-gray-600"
        // fontSize="24px"
        data-cy="change-password-subtitle"
      >
        Welcome! For security reasons, please change your default password
        before continuing.
      </Typography>

      <Box
        component="form"
        marginTop="2em"
        noValidate
        onSubmit={handleSubmit}
        data-cy="change-password-form"
      >
        <PasswordInput
          {...{
            name: "newPassword",
            label: "New Password",
            value: values.newPassword,
            error: errors.newPassword && touched.newPassword,
            helperText:
              errors.newPassword && touched.newPassword
                ? errors.newPassword
                : "",
            onChange: handleChange,
            onBlur: handleBlur,
            required: true,
            "data-cy": "change-password-new-password-input",
          }}
        />

        <PasswordInput
          {...{
            name: "confirmPassword",
            label: "Confirm Password",
            value: values.confirmPassword,
            error:
              (errors.confirmPassword && touched.confirmPassword) || !isMatch,
            helperText:
              (errors.confirmPassword && touched.confirmPassword) || !isMatch
                ? errors.confirmPassword || error
                : "",
            onChange: handleChange,
            onBlur: handleBlur,
            required: true,
            "data-cy": "change-password-confirm-password-input",
          }}
        />

        <LoadingButton
          className="my-10 rounded-[10px] bg-[var(--c-primary-0)] hover:bg-[var(--c-primary-1)]"
          sx={{
            ".MuiLoadingButton-loadingIndicatorCenter": {
              color: "var(--c-bg-color) !important",
            },
          }}
          size="large"
          type={isMatch ? "submit" : "button"}
          variant="contained"
          fullWidth
          loading={loading && isMatch}
          data-cy="change-password-submit-button"
        >
          Change Password
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default ChangePassword;
